import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ProgressBar } from 'react-bootstrap';
import ImportStatus from '../import_status';

export class Run extends React.Component {
  static propTypes = {
    files: PropTypes.object.isRequired,
    importStatus: PropTypes.number.isRequired
  }

  renderProgressBar() {
    const { files, importStatus } = this.props;
    return (
      <div className="panel panel-default">
        <div className="p-5">
          <div className="h2 semibold mt-0">Running Import</div>
          <div className="larger-text mb-4">
            Buildout is now importing your data from {Object.keys(files).length} files.
            This page will update when the import is ready.
          </div>
          <ProgressBar label={`${importStatus}%`} now={importStatus}/>
        </div>
        <ImportStatus importStatus={["complete"]}/>
      </div>
    );
  }

  render() {
    return (
      <div className="container step-container run">
        {this.renderProgressBar()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  files: state.importObject.files,
  importStatus: state.ui.importStatus,
});

export default connect(mapStateToProps)(Run);